import type { QueryClient } from '@tanstack/react-query';
import {
  fetchProductReviews,
  PRODUCT_REVIEWS_KEY,
} from 'hooks/reviews/useProductReviews';
import { REVIEWED_PRODUCTS_KEY } from 'hooks/reviews/useReviewedProducts';
import { GLOBALS_KEY } from 'hooks/useGlobals';
import type { Globals } from 'types/cms/Globals';
import type { JunipProduct } from 'types/reviews/JunipProduct';
import { reviewedProductsSelector } from 'utils/reviews/reviewedProductsSelector';

// This is assuming the prefetchCommonData has already been called
export const prefetchReviewsData = async (queryClient: QueryClient) => {
  const globals = queryClient.getQueryData([GLOBALS_KEY]) as Globals;

  const reviewedProducts = queryClient.getQueryData([
    REVIEWED_PRODUCTS_KEY,
  ]) as JunipProduct[];

  const productReviewIds = reviewedProductsSelector({
    globals,
    reviewedProducts,
  })
    ?.filter((item) => (item.ratingCount ?? 0) > 0)
    .map((item) => item.id.toString());

  if (productReviewIds?.length) {
    await queryClient.prefetchQuery({
      queryKey: [PRODUCT_REVIEWS_KEY, productReviewIds, null, false],
      queryFn: fetchProductReviews,
    });
  }
};
